import type {State} from '../../../../../reducers/types'

import type {QueueCountersByPool} from './QueueSidebar.types'

export const getPoolCounters: (arg0: State) => QueueCountersByPool = state =>
  state.queueSidebar.counters
